module.exports = __webpack_public_path__ + "static/media/main5_en_768-min.be929d42.png";